import React from 'react';
import { DetailsWrapper } from './Styles';
import CopyPopup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import { copyCommand } from '../../utils/library';
import { COPY_ICON } from '@Images';

interface BankDetailsCardProps {
  dataArray: {
    key: string;
    value: string;
    extraInfo?: string;
  }[];
  width?: string;
}

export const BankDetailsCard: React.FC<BankDetailsCardProps> = (props): React.ReactElement => {
  const { dataArray, width } = props;
  return (
    <>
      {dataArray.map((item: any, index: number) => (
        <DetailsWrapper key={index} width={width}>
          <div className="inner-wrapper">
            <div className="heading-wrapper">
              <div className="heading">{item?.key}</div>
              <div className="subHeading" id={index?.toString()}>
                {item?.value}
              </div>
            </div>
            <CopyPopup
              id="ack_Popup"
              on="click"
              hideOnScroll={true}
              trigger={
                <img
                  onClick={() => {
                    copyCommand(index?.toString());
                  }}
                  src={COPY_ICON}
                  alt="copy"
                  width="24px"
                  height="24px"
                  className="copyIcon"
                />
              }
              content={'Copied!!'}
            />
          </div>
          {item?.extraInfo && <div className="extraInfo">{item?.extraInfo}</div>}
        </DetailsWrapper>
      ))}
    </>
  );
};
